import "./SuccessPopup.css"

const SuccessPopup = ({ isVisible }) => {
  if (!isVisible) return null

  return (
    <div className="success-popup-overlay">
      <div className="success-popup-card">
        {/* <div className="success-icon"> */}
        {/* <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M30 1.875C24.4374 1.875 18.9997 3.5245 14.3746 6.61492C9.74947 9.70533 6.14462 14.0979 4.0159 19.237C1.88719 24.3762 1.33022 30.0312 2.41543 35.4869C3.50064 40.9426 6.17928 45.954 10.1126 49.8874C14.046 53.8207 19.0574 56.4994 24.5131 57.5846C29.9688 58.6698 35.6238 58.1128 40.763 55.9841C45.9022 53.8554 50.2947 50.2505 53.3851 45.6254C56.4755 41.0003 58.125 35.5626 58.125 30C58.125 22.5408 55.1619 15.3871 49.8874 10.1126C44.6129 4.83816 37.4592 1.875 30 1.875ZM30 54.9938C25.0567 54.9938 20.2244 53.5279 16.1142 50.7815C12.004 48.0352 8.80052 44.1317 6.9088 39.5647C5.01708 34.9977 4.52212 29.9723 5.48651 25.124C6.4509 20.2756 8.83132 15.8222 12.3268 12.3267C15.8222 8.83131 20.2757 6.45089 25.124 5.4865C29.9723 4.52211 34.9977 5.01707 39.5647 6.90879C44.1317 8.8005 48.0352 12.004 50.7816 16.1142C53.5279 20.2244 54.9938 25.0567 54.9938 30C54.9838 36.6257 52.3474 42.9772 47.6623 47.6623C42.9772 52.3474 36.6257 54.9838 30 54.9938Z" fill="#29CB97" />
          <path d="M26.0805 34.8555L20.0805 28.8555L17.418 31.4992L26.0805 40.143L44.268 21.9555L41.6242 19.293L26.0805 34.8555Z" fill="#29CB97" />
        </svg> */}

        <img src="/assets/icons/common/green-check.svg" />

        {/* </div> */}
        <h2>Account Created</h2>
        <p>Successfully!</p>
      </div>
    </div>
  )
}

export default SuccessPopup
